import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'submitButtonLabel'
  | 'nextButtonLabel'
  | 'backButtonLabel'
  | 'footerIsAuthenticationRequired'
  | 'footerCheckboxAgreeTOS';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  submitButtonLabel: {
    id: 'boxFileRequest.submitButton.buttonLabel',
    description: 'Label for Submit Button',
    defaultMessage: 'Submit',
  },
  nextButtonLabel: {
    id: 'boxFileRequest.nextButton.buttonLabel',
    description: 'Label for Next Button',
    defaultMessage: 'Next',
  },
  backButtonLabel: {
    id: 'boxFileRequest.backButton.buttonLabel',
    description: 'Label for Back Button',
    defaultMessage: 'Back',
  },
  footerIsAuthenticationRequired: {
    id: 'boxFileRequest.footer.requiresLogin.description',
    description:
      'Description for when upload is submitted and login required, where email is the email address of the uploader, and logout is a logout link',
    defaultMessage:
      'Your email address {email} will be recorded when you submit (<a>log out</a>).',
  },
  footerCheckboxAgreeTOS: {
    id: 'boxFileRequest.footer.footerCheckboxAgreeTOS',
    description:
      "Message informing user that by checking a box they are agreeing to Box's TOS and Privacy Notice",
    defaultMessage:
      "By checking this box you agree to Box's <a>Terms of Service</a> and confirm you have read Box's <b>Privacy Notice</b>.",
  },
});

export default messages;
